var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('notification',{attrs:{"closeButton":true},on:{"close":_vm.onClose}},[[_vm._v(_vm._s(_vm.$t('Important! The data represented below is not a bill. It is provided for reference only.')))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }